import React, { useState } from 'react';
import styles from './input.sass';

const Input = ({ placeholder, condition, ...props }) => {
  const [state, setState] = useState({
    status: 'default',
    active: false,
  });

  const handleFocus = () => {
    setState({
      status: 'default',
      active: true,
    });
  };

  const handleBlur = () => {
    setState({
      status: (condition && 'suceess') || 'error',
      active: !!props.value.length,
    });
  };

  let status;
  if (condition) {
    status = 'success';
  } else if (!condition && !!props.value) {
    status = 'error';
  } else {
    status = 'default';
  }

  return (
    <div
      className={`
        ${styles.container}
        ${styles[status] || ''}
        ${((state.active || props.value.length) && styles.active) || ''}
      `}>
      <label className={styles.label}>{placeholder}</label>
      <input {...props} onFocus={handleFocus} onBlur={handleBlur} />
    </div>
  );
};

export default Input;
